﻿const isBase64 = (value: string) => {
    try {
        return btoa(atob(value)) === value;
    } catch (error) {
        return false;
    }
};

export default isBase64;